/* eslint-disable max-len */

import translateEn from 'core/i18n/resources/en';

const TRANSLATIONS_EN = {
  ...translateEn,
};

export default TRANSLATIONS_EN;
